/*
 * @Description: 养成-成本概览
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-02-23 16:17:53
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/outSaleCostGroup/searchOutSaleCostGroupList`
  return http.post(url, data)
}

// 获取所有机构--成本概览
export function getAllJiGou(data){
  const url = `/outSaleCostGroup/getGroupConditions`
  return http.post(url,data)
}

// 获取所有造次--实时存塘量
export function getAllPiCi(data){
  const url = `/outSaleCostGroup/getPeriodConditions`
  return http.post(url,data)
}
// 获取所有品类--实时存塘量
export function getAllPinLei(data){
  const url = `/outSaleCostGroup/getTypeConditions`
  return http.post(url,data)
}
// 获取所有品种--实时存塘量
export function getAllPinZhong(data){
  const url = `/outSaleCostGroup/getBreedConditions`
  return http.post(url,data)
}

